import * as types from "./actions";
import {  MAX_11_DIGITS } from "../../../../utils/constants";

const defaultState = {
    list: [],
    pageCount: 0,
    pageSize: 20,
    tableHeader:[
        {
            label: "取引先コード（主番）", 
            button:false,
            rightAlign: true
        },
        {
            label: "取引先コード（枝番）", 
            button:false,
            rightAlign: true
        },
        {
            label: "取引先名", 
            button:false
        },
        {
            label: "編集",
            button:true
        },
        {
            label: "コピー",
            button:true
        }
    ],
    tableColumns:[
        "mainNumber",
        "branchNumber",
        "businessPartnerName"
    ],
    form:[
        {
            type: "number",
            label: "取引先コード（主番）",
            placeholder: "",
            min: 0,
            max: MAX_11_DIGITS,
            name: "mainNumber",
            disabled: false,
            readOnly:true,
            required: true
        },
        {
            type: "number",
            label: "取引先コード（枝番）",
            placeholder: "",
            min: 0,
            max: MAX_11_DIGITS,
            name: "branchNumber",
            disabled: false,
            readOnly:true,
            required: true
        },
        {
            type: "text",
            label: "取引先名",
            placeholder: "",
            minLength: 1,
            maxLength: 40,
            name: "businessPartnerName",
            required: true
        },
        {
            type: "text",
            label: "フリガナ",
            placeholder: "",
            minLength: 1,
            maxLength: 20,
            name: "businessPartnerKana",
            hasDefault:true,
        },
        {
            type: "email",
            label: "メールアドレス",
            placeholder: "",
            name: "email",
            minLength: 5,
            maxLength: 256,
            optional: true
        },
        {
            type: "text",
            label: "ログインID",
            placeholder: "",
            minLength: 8,
            maxLength: 16,
            name: "loginId",
            required: true,
            hasDefault:true,
        },
        {
            type: "text",
            label: "パスワード",
            placeholder: "",
            minLength: 8,
            maxLength: 16,
            name: "password",
            hasDefault:true,
            required: true
        },
        {
            type: "radio",
            label: "予測値の表示",
            name: "forecastValue",
            inline:true,
            hasDefault:true,
            required: true
        },
        {
            type: "text",
            label: "電話番号",
            placeholder: "",
            minLength: 1,
            maxLength: 13,
            name: "tel",
            optional: true,
        }
    ],
    radioButtonInput:[
        {
            name:"forecastValue",
            value:"1",
            label:"する"
        },
        {
            name:"forecastValue",
            value:"0",
            label:"しない"
        },
        {
            name:"priceDisplay",
            value:true,
            label:"表示"
        },
        {
            name:"priceDisplay",
            value:false,
            label:"非表示"
        }
    ]
}

export default function reducer (state=defaultState, action) {
    switch (action.type) {
        case types.LIST:
            return {...state, list: action.payload.list, pageCount: action.payload.pageCount};
        case types.SIZE:
            return { ...state, pageSize: action.payload };
        default: // need this for default case
            return state 
    }
};
